export default __webpack_public_path__ + "static/media/navbar-visit-history-orange.21d1106a.svg";